// src/constants/index.ts
var WIDGET_TYPES = {
  KPI_CARDS: "kpi-cards",
  TREND_LINE: "trend-line",
  DATA_TABLE: "data-table",
  RADAR_CHART: "radar-chart",
  SCORE_GAUGE: "score-gauge",
  CHANNEL_CARD: "channel-card",
  CHANGE_ALERT: "change-alert",
  SUGGEST_CHIPS: "suggest-chips",
  COMPARISON_TABLE: "comparison-table",
  STEP_PROGRESS: "step-progress",
  BID_CHART: "bid-chart",
  SEO_CHECKLIST: "seo-checklist",
  TIMELINE_CHART: "timeline-chart",
  HEATMAP: "heatmap",
  HIGHLIGHT_BOX: "highlight-box",
  BANNER_ALERT: "banner-alert",
  FORM_CONFIRM: "form-confirm",
  MARKDOWN_REPORT: "markdown-report",
  IMAGE_CARD: "image-card",
  ERROR_STATE: "error-state"
};
var WIDGET_MAP = {
  // Dashboard & Overview
  dashboard: WIDGET_TYPES.KPI_CARDS,
  get_dashboard: WIDGET_TYPES.KPI_CARDS,
  keyword_overview: WIDGET_TYPES.KPI_CARDS,
  monitoring_overview: WIDGET_TYPES.KPI_CARDS,
  // Trends & Timeline
  keyword_trends: WIDGET_TYPES.TREND_LINE,
  trend_data: WIDGET_TYPES.TREND_LINE,
  keyword_monthly_stats: WIDGET_TYPES.TIMELINE_CHART,
  // Tables
  keyword_list: WIDGET_TYPES.DATA_TABLE,
  list_keywords: WIDGET_TYPES.DATA_TABLE,
  keyword_rankings: WIDGET_TYPES.DATA_TABLE,
  channel_list: WIDGET_TYPES.DATA_TABLE,
  list_channels: WIDGET_TYPES.DATA_TABLE,
  content_list: WIDGET_TYPES.DATA_TABLE,
  list_contents: WIDGET_TYPES.DATA_TABLE,
  search_result: WIDGET_TYPES.DATA_TABLE,
  search_results: WIDGET_TYPES.DATA_TABLE,
  bid_list: WIDGET_TYPES.DATA_TABLE,
  list_keyword_bids: WIDGET_TYPES.DATA_TABLE,
  classify_result: WIDGET_TYPES.DATA_TABLE,
  // Scores
  score_result: WIDGET_TYPES.RADAR_CHART,
  score_aggregate: WIDGET_TYPES.SCORE_GAUGE,
  score_seo: WIDGET_TYPES.SEO_CHECKLIST,
  // Channels
  channel_profile: WIDGET_TYPES.CHANNEL_CARD,
  channel_blog_profile: WIDGET_TYPES.CHANNEL_CARD,
  channel_cafe_profile: WIDGET_TYPES.CHANNEL_CARD,
  channel_influencer_profile: WIDGET_TYPES.CHANNEL_CARD,
  // Monitoring
  monitoring_changes: WIDGET_TYPES.CHANGE_ALERT,
  // Search Suggestions
  search_suggest: WIDGET_TYPES.SUGGEST_CHIPS,
  // Comparisons
  keyword_detail: WIDGET_TYPES.COMPARISON_TABLE,
  // Bids
  bid_collect: WIDGET_TYPES.BID_CHART,
  collect_keyword_bids: WIDGET_TYPES.BID_CHART
};
var DEEPLINK_MAP = {
  list_keywords: "/keywords/explorer/list",
  keyword_detail: (d) => d?.keyword ? `/keywords/details/${encodeURIComponent(d.keyword)}` : "/keywords",
  keyword_overview: "/keywords",
  keyword_monthly_stats: "/keywords/data/stats",
  keyword_rankings: "/keywords/data/rankings",
  keyword_trends: "/keywords/data/trends",
  list_channels: "/channels/explorer",
  list_contents: "/contents/explorer",
  search_results: "/search-results",
  list_keyword_bids: "/search-marketing/keywords/explorer",
  monitoring_overview: "/monitoring",
  monitoring_changes: "/monitoring/anomalies",
  get_dashboard: "/dashboard"
};
function resolveDeeplink(toolName, data) {
  const entry = DEEPLINK_MAP[toolName];
  if (!entry) return void 0;
  if (typeof entry === "string") return entry;
  try {
    return entry(data);
  } catch {
    return void 0;
  }
}
function selectWidget(ctx) {
  const { mcpWidget, toolName, rowCount, preferCompact } = ctx;
  if (mcpWidget && WIDGET_MAP[mcpWidget]) {
    const mapped = WIDGET_MAP[mcpWidget];
    return mapped;
  }
  if (toolName && WIDGET_MAP[toolName]) {
    return WIDGET_MAP[toolName];
  }
  if (rowCount === 0) return WIDGET_TYPES.ERROR_STATE;
  if (rowCount === 1) return WIDGET_TYPES.HIGHLIGHT_BOX;
  if (rowCount !== void 0 && rowCount > 1) {
    return preferCompact ? WIDGET_TYPES.COMPARISON_TABLE : WIDGET_TYPES.DATA_TABLE;
  }
  return WIDGET_TYPES.HIGHLIGHT_BOX;
}
var LATENCY_BUDGET = {
  // Frontend → Supabase Edge Function
  FE_TO_EF: { p50: 80, p99: 200 },
  // ms
  // Edge Function → LLM (첫 토큰)
  EF_TO_LLM_FIRST_TOKEN: { p50: 700, p99: 1800 },
  // Edge Function → MCP Tool (in-process)
  EF_TO_MCP_TOOL: { p50: 300, p99: 1200 },
  // MCP Tool → CH/Naver API
  MCP_TO_UPSTREAM: { p50: 250, p99: 900 },
  // 전체 첫 응답 (first-token)
  TOTAL_FIRST_TOKEN: { p50: 1200, p99: 3500 },
  // 전체 도구 결과 반영 완료
  TOTAL_TOOL_COMPLETE: { p50: 2500, p99: 6500 }
};
var TIER_LIMITS = {
  free: {
    monthlyCall: 50,
    monthlyToken: 2e5,
    concurrentStreams: 1,
    maxMessageChars: 1e3
  },
  starter: {
    monthlyCall: 500,
    monthlyToken: 2e6,
    concurrentStreams: 2,
    maxMessageChars: 2e3
  },
  pro: {
    monthlyCall: 5e3,
    monthlyToken: 2e7,
    concurrentStreams: 4,
    maxMessageChars: 2e3
  },
  enterprise: {
    monthlyCall: 5e4,
    monthlyToken: 2e8,
    concurrentStreams: 10,
    maxMessageChars: 4e3
  }
};
export {
  DEEPLINK_MAP,
  LATENCY_BUDGET,
  TIER_LIMITS,
  WIDGET_MAP,
  WIDGET_TYPES,
  resolveDeeplink,
  selectWidget
};
//# sourceMappingURL=index.js.map